const locale = {
	apply: "Apply",
	undo: "Undo",
	redo: "Redo",
	selectFontFamily: "Font",
	selectFontSize: "Font size",
	selectFormat: "Style",
	selectTextColor: "Text color",
	selectTextBackground: "Background color",
	markBold: "Bold",
	markItalic: "Italic",
	markStrike: "Strike",
	markUnderline: "Underline",
	alignLeft: "Align left",
	alignCenter: "Align center",
	alignRight: "Align right",
	addLink: "Add link",
	clearFormat: "Clear formatting",
	fullscreen: "Fullscreen",
	stats: "Statistics",
	removeLink: "Remove link",
	edit: "Edit",
	h1: "Heading 1",
	h2: "Heading 2",
	h3: "Heading 3",
	h4: "Heading 4",
	h5: "Heading 5",
	h6: "Heading 6",
	p: "Normal text",
	blockquote: "Block quote",
	chars: "chars",
	charsExlSpace: "Characters without spaces",
	words: "words",
	link: "Link",
	text: "Text",
};

export default locale;
